import axios from 'axios';
import React, { Fragment, useContext, useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import {Link, useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2';
import { CompanyContext } from '../../../Context/CompanyContext.js';
import { UserContext } from '../../../Context/UserContext.js';



export default function SpecificCompany() {
   
   const{id} = useParams () ;
   const{getCompany , company , testCount } = useContext(CompanyContext)
   const {userToken } = useContext(UserContext) ;
   const navigate = useNavigate()


   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }


   async function deleteCompany(){
      Swal.fire({
         title: "Are you sure?",
         text: "You won't be able to revert this!",
         icon: "warning",
         showCancelButton: true,
         confirmButtonColor: "#3085d6",
         cancelButtonColor: "#d33",
         confirmButtonText: "Yes, delete it!"
      }).then(async(result) => {
         if (result.isConfirmed) {
            let response =   await axios.delete(`${process.env.REACT_APP_BASE_URL}/api/v1/company/${id}`  ,  {headers:header} )
            .catch((error)=>{
               Swal.fire({
                  title:error.response.data.message  ,
                  text: "Please Try Again" ,   
                  icon: "error"
                  });
            })
            if(response?.data.message === "success"){
               Swal.fire({
                  title: "Successfully Deleted Company",
                  text: "Your file has been deleted.",
                  icon: "success"
               });
               navigate("/dashboard/companyDashboard")
            }
         }
      });
   }


   useEffect(() => {
      getCompany(id)
   }, [])
   
   return (
      <Fragment>
         <div className="container mt-5">
            <h1 className='main-header'>Specific Company</h1>
            <div className='under-header'></div>

            <div className="row ">
               <div className="col-md-12 mb-4">
                  <h4 className='fw-bold'>Company Information :</h4>
                  <div className='border border-1 p-2 rounded-2'>

                     <table className="table table-sm table-striped">

                        <tbody>
                           <tr>
                              <th scope="row">Name :</th>
                              <td>{company.name}</td>
                           </tr>
                           <tr>
                              <th scope="row">Phone:</th>
                              <td>{company.phone}</td>
                           </tr>
                           <tr>
                              <th scope="row">Email:</th>
                              <td>{company.email}</td>
                           </tr>
                           <tr>
                              <th scope="row">Services:</th>
                              <td>{company.service}</td>
                           </tr>
                           <tr>
                              <th scope="row">Description:</th>
                              <td>{company.description}</td>
                           </tr>
                           <tr>
                              <th scope="row">State:</th>
                              <td>{company.isActive? <p className='text-success'>Active Company</p> : <p className='text-danger'>Not Active Company</p>}</td>
                           </tr>

                           <tr>
                              <th scope="row">Test Count:</th>
                              <td>{testCount}</td>
                           </tr>

                           <tr>
                              <th scope="row">Logo:</th>

                              <td className='text-center'>
                                 <img src={company.logo} className='w-25' alt={company.name} />
                              </td>
                           </tr>

                        </tbody>
                     </table>

                     <div className='text-center'>
                        <button onClick={()=>{deleteCompany()}}  className='btn btn-sm btn-outline-danger'>Delete Company <i className="fa-solid fa-trash px-2"></i></button>
                        <Link to="/dashboard/changeImageCompany"   className='btn btn-sm btn-outline-primary m-2'>Change Image</Link>
                        <Link to={`/dashboard/updateCompany/${company._id}`}  className='btn btn-sm btn-outline-success'>Update Company  <i className="fa-solid fa-pen ms-2"></i></Link>
                     </div>
                     
                  </div>
               </div>
            </div>
         </div>
      </Fragment>
   )
}
